import React from 'react';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import PasswordField from 'shared/components/password-field/PasswordField';
import Button from 'shared/components/button/Button';
import { setPasswordSchema } from 'utils/validators/setPassword';
import { setPassword, validCode } from '../../ducks/actionsAuthActions';
import InvalidAction from '../InvalidAction/InvalidAction';
import './PasswordReset.scss';

class PasswordReset extends React.Component {
  componentDidMount() {
    this.props.validCode(this.props.code);
  }

  render() {
    const { code, passwordUpdated, invalidLink, continueUrl } = this.props;

    if (passwordUpdated) {
      if (continueUrl.includes("trainer_login")) {
        return window.location.assign(process.env.REACT_APP_DYNAMIC_LINK_DOMAIN + 'trainer_login');
      }
      return window.location.assign(process.env.REACT_APP_DYNAMIC_LINK_DOMAIN + 'client_login');
    }

    if (invalidLink) {
      return (
        <InvalidAction
          title="Invalid Link"
          description="Your reset password link is invalid or has expired!"
        />
      );
    }

    return (
      <Formik
        validationSchema={setPasswordSchema}
        initialValues={{ password: '', confirmPassword: '' }}
        onSubmit={values => {
          return this.props.setPassword(code, values.password);
        }}
      >
        {({ values, errors, isSubmitting }) => (
          <Form>
            <div className="onboarding">
              <div className="new-password reset-password">
                <div className="form-side">
                  <div className="shape shape-left"></div>
                  <div className="shape shape-right"></div>
                  <div className="form-content">
                    <h3>Create a new password</h3>
                    <p>Password must include at least 6 characters.</p>
                    <PasswordField />
                    <PasswordField
                      name="confirmPassword"
                      label="Confirm Password"
                    />
                    <label
                      className={`password-check form-check-label ${
                        values['password'].length === 0 || errors['password']
                          ? ''
                          : 'active'
                      }`}
                    >
                      <i className="fas fa-check-square"></i>
                      <span>At least 6 characters long</span>
                    </label>
                    <div className="form-action">
                      <Button
                        id=""
                        type="submit"
                        btnBlock="block"
                        color="primary"
                        label="Change Password"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    passwordUpdated: state.actionsReducer.passwordUpdated,
    invalidLink: state.actionsReducer.invalidCode
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setPassword: (code, newPassword) =>
      dispatch(setPassword(code, newPassword)),
    validCode: code => dispatch(validCode(code))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordReset);
